// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3e582687","453":"365d32eb","667":"65ca5892","977":"7587fc3e"}[chunkId] + ".chunk.js";
};